import {
    HttpInterceptorFn,
    provideHttpClient,
    withInterceptors,
} from '@angular/common/http';
import { AuthRequestInterceptor } from 'shared/core/data-access/auth';
import { EmptyValueInterceptor } from '../../interceptors/empty-value/empty-value.interceptor';
import { FileUploadInterceptor } from '../../interceptors/file-upload/file-upload.interceptor';
import { HttpLanguageInterceptor } from '../../interceptors/http-language/http-language.interceptor';
import { XhrRequestInterceptor } from '../../interceptors/xhr-request/xhr-request.interceptor';

export const provideApi = (interceptors?: HttpInterceptorFn[]) => [
    provideHttpClient(
        withInterceptors([
            AuthRequestInterceptor,
            HttpLanguageInterceptor,
            FileUploadInterceptor,
            EmptyValueInterceptor,
            XhrRequestInterceptor,
            ...(interceptors ?? []),
        ]),
    ),
];
